var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconInGreenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2866_11454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#1FC66C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7553 29.754L6.44066 21.9252C5.43925 20.8533 5.49673 19.1576 6.56854 18.1562C7.64035 17.1548 9.3361 17.2124 10.3375 18.2841L15.9797 24.3228L24.9106 15.9784C24.9909 15.9033 25.0748 15.8344 25.1616 15.7711L29.3615 11.8472C30.4333 10.8458 32.1292 10.9034 33.1304 11.9752C34.1318 13.0469 34.0742 14.7428 33.0026 15.7442L20.1752 27.7293L20.1615 27.7146L15.7243 31.8604L13.7553 29.754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2866_11454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconInGreenBg);
export default __webpack_public_path__ + "static/media/check-icon-in-green-bg.1184fd8a6b7584f1b81593aa2291ce43.svg";
export { ForwardRef as ReactComponent };